import React, { useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';

// Pilihan radius absen yang umum dipakai; selain ini pakai "Custom".
const PILIHAN = [
  { meter: 50, label: '50 m — ruko / toko kecil' },
  { meter: 100, label: '100 m — satu bangunan (disarankan)' },
  { meter: 150, label: '150 m — bangunan + halaman' },
  { meter: 200, label: '200 m — bangunan + parkiran' },
  { meter: 300, label: '300 m — mal / gedung besar (GPS sering lemah)' },
  { meter: 500, label: '500 m — kawasan / area luas' },
  { meter: 1000, label: '1 km' },
];
const adaDiPilihan = (v) => PILIHAN.some((p) => p.meter === Number(v));

/** Radius absen cabang: pilih dari saran, atau "Custom" untuk mengisi angka sendiri. */
const PilihRadiusAbsen = ({ value, onChange }) => {
  const terisi = value !== undefined && value !== null && String(value).trim() !== '';
  const [custom, setCustom] = useState(terisi && !adaDiPilihan(value));

  // Nilai tersimpan di luar pilihan (mis. 30000) langsung tampil sebagai Custom.
  useEffect(() => {
    if (terisi && !adaDiPilihan(value)) setCustom(true);
  }, [value, terisi]);

  const pilihan = custom ? 'custom' : (terisi && adaDiPilihan(value) ? Number(value) : '');

  return (
    <>
      <FormControl fullWidth margin="normal">
        <InputLabel id="radius-absen-label">Radius absen</InputLabel>
        <Select
          labelId="radius-absen-label"
          label="Radius absen"
          value={pilihan}
          onChange={(e) => {
            if (e.target.value === 'custom') {
              setCustom(true);
            } else {
              setCustom(false);
              onChange(String(e.target.value));
            }
          }}
        >
          {PILIHAN.map((p) => (
            <MenuItem key={p.meter} value={p.meter}>{p.label}</MenuItem>
          ))}
          <MenuItem value="custom">Custom (isi sendiri)…</MenuItem>
        </Select>
        <FormHelperText>Jarak maksimal karyawan dari titik cabang saat absen.</FormHelperText>
      </FormControl>
      {custom && (
        <TextField
          name="radius"
          label="Radius custom (meter)"
          type="number"
          fullWidth
          margin="dense"
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
          inputProps={{ min: 10, max: 100000 }}
          helperText="Isi angka 10–100.000 meter."
        />
      )}
    </>
  );
};

export default PilihRadiusAbsen;
